import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { accountTransfersSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const AccountTransfers = () => (
  <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.ACCOUNT_TRANSFERS} items={accountTransfersSubpages} />
);

export default AccountTransfers;
